<template lang="pug">
    v-text-field.mr-4(
        v-bind="textFieldProps"
        v-model="_value"
        :single-line="true"
        :outline='true'
        @keydown="handleDot($event)"
        ref="input"
        )
        //.form-label.mt-1(slot='prepend' v-if='showLabels')
            slot(name="prepend")
        span.subheading.font-weight-bold.mr-2.mt-1(slot='prepend-inner')
            slot(name="prepend-inner")
</template>

<script>
import { CurrencyUtils } from '@/mixins/reusable_mixins'
export default {
    name: 'float-input',
    data: function() {
        return {}
    },
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        textFieldProps: {
            type: Object,
            default: function() {
                return {}
            },
        },
        showLabels: {
            type: Boolean,
            default: () => true,
        },
        rules: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        /**
         * @description
         */
        _value: {
            get: function() {
                return this.formatFloat(this.value)
            },
            set: function(val) {
                this.$emit('input', this.unFormatFloat(val))
            },
        },
        _rules() {
            return this.rules.concat(this.mixRUTRules.validRUT)
        },
    },
    methods: {
        formatFloat(number) {
            //if (isNaN(number)) return ''
            if (number === '-') return number
            let num = '' + number
            num = num.split('.')
            let int = this.formatCurrency(num[0])
            let float = num.length > 1 ? `,${num[1]}` : ''
            return int + float
        },
        unFormatFloat(string) {
            let arr = string.split(',')
            let int = arr[0]
            int = arr[0].split('.').join('')
            let float = arr.length > 1 ? `.${arr[1]}` : ''
            return int + float
        },
        handleDot(e) {
            if ((this._value.includes(',') && e.key === ',') || e.key === '.') {
                e.preventDefault()
                e.stopPropagation()
            }
        },
    },
    watch: {
        value: {
            handler(val, oldval) {
                //console.log(val, oldval)

                if (isNaN(val) && val !== '-') {
                    this.$nextTick(() => {
                        this._value = ''
                        this.$nextTick(
                            () => (this._value = this.formatFloat(oldval))
                        )
                    })
                    return
                    let dotted = val.split('.')
                    let str = ''
                    if (dotted.length > 2) {
                        let first = dotted[0] + '.' + dotted[1]
                        let second = dotted.reduce((fin, str, idx) => {
                            if (idx > 1) {
                                fin = '' + fin + str
                            }
                            return fin
                        }, '')
                        str = '' + first + second
                        this.$nextTick(() => {
                            this._value = ''
                            this.$nextTick(
                                () => (this._value = this.formatFloat(str))
                            )
                        })
                    } else {
                        this.$nextTick(
                            () => (this._value = this.formatFloat(oldval))
                        )
                    }
                }
            },
        },
    },
    mixins: [CurrencyUtils],
}
</script>

<style lang="scss">
.formLabel {
    font-weight: bold;
    min-width: 150px;
    max-width: 150px;
    font-size: 20px;
}
</style>
